import * as React from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import {TransitionProps} from '@mui/material/transitions'
import Form from './Form'
import EditForm from './EditForm'
import {useTranslation} from 'react-i18next'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function Edit({
  setOpen,
  open,
  item,
  setItem,
  rows,
  setRows,
}: // rows,
// setRows,
any) {
  const handleClose = () => {
    if (!iloading) {
      setOpen(false)
    }
  }
  const [iloading, setIsLoading] = React.useState(false)

  return (
    <div>
      <></>

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: 'var(--bs-body-bg)', // تعديلاتك الخاصة هنا
          },
          '& .MuiDialog-paperWidthSm': {
            maxWidth: '600px', // تعديلاتك الخاصة هنا
          },
        }}
      >
        <EditForm
          setIsLoading={setIsLoading}
          iloading={iloading}
          rows={rows}
          setRows={setRows}
          setItem={setItem}
          item={item}
          open={open}
          setOpen={setOpen}
        />
      </Dialog>
    </div>
  )
}
